import { useRef, useState, useEffect } from "react";
import { BsPlayCircle, BsPauseCircle } from "react-icons/bs";

// Play-Button für eine vorab generierte TTS-MP3 (ElevenLabs).
// WICHTIG: Die Audiodatei wird ERST beim ersten Klick geladen — das Audio-
// Objekt wird lazy im Handler erzeugt (kein <audio>-Tag im JSX, das würde
// sonst schon Metadaten/Datei vorladen). Nichts lädt beim Anzeigen.
export default function TtsPlayButton({ src, label }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  // Bei Quellwechsel (anderer Text) laufendes Audio stoppen und verwerfen.
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
        audioRef.current = null;
      }
    };
  }, [src]);

  const toggle = (e) => {
    e.stopPropagation();
    if (!src) return;

    // Lazy: Audio-Objekt erst jetzt erzeugen → Download startet erst hier.
    if (!audioRef.current) {
      const audio = new Audio();
      audio.preload = "none";
      audio.src = src;
      audio.addEventListener("ended", () => setPlaying(false));
      audio.addEventListener("pause", () => setPlaying(false));
      audio.addEventListener("play", () => setPlaying(true));
      audioRef.current = audio;
    }

    const audio = audioRef.current;
    if (audio.paused) {
      audio.play().catch(() => setPlaying(false));
    } else {
      audio.pause();
    }
  };

  if (!src) return null;

  return (
    <button
      onClick={toggle}
      aria-label={playing ? "Vorlesen pausieren" : "Text vorlesen"}
      className="inline-flex items-center gap-1.5 text-white/90 hover:text-lime-400 transition-colors cursor-pointer"
    >
      {playing ? <BsPauseCircle size={22} /> : <BsPlayCircle size={22} />}
      {label && <span className="text-xs font-roboto font-light tracking-wide">{label}</span>}
    </button>
  );
}
